import {openDialog} from 'platform/components';

import {CustomNoticeListItem} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {CustomNoticeDialog} from '../components/CustomNoticeDialog/CustomNoticeDialog';

interface OpenEditCustomNoticeDialogProps extends TestIdProps {
  resourceId: EntityResourceIds;
  recordId: string;
  notice: CustomNoticeListItem;
}

export function openEditCustomNoticeDialog(props: OpenEditCustomNoticeDialogProps) {
  openDialog(
    <CustomNoticeDialog
      mode="edit"
      resourceId={props.resourceId}
      recordId={props.recordId}
      notice={props.notice}
      data-testid={suffixTestId('editCustomNotice', props)}
    />,
    {
      title: i18n.t('general.customNotices.actions.edit'),
      size: 'small',
      scrollBehavior: 'outside',
      'data-testid': suffixTestId('editCustomNotice', props),
    }
  );
}
